define([
    'react',
    'lodash',
    'text/index',
    './style'
], function (React, _, Text, Styles) {
    'use strict';
    return function () {
        return React.createElement('div', { 'className': Styles.globalPageTitle }, React.createElement('h2', { 'className': this.getClass() }, this.props.title));
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/title/title/title.rt
 ** module id = 124
 ** module chunks = 0
 **/